import { START_LOCATION } from 'vue-router'
import { shouldCoverNavigation } from '~/utils/routeLoading'

// Decides whether the global loading overlay covers this navigation. AB#64327
//
// It used to be decided in CustomLoading from Nuxt's page:loading:start hook, which carries
// no route, and corrected in a later router guard. Nuxt awaits route middleware between the
// two, so either a frame painted with the wrong state (a white flash on query-only clicks)
// or the cover came up only after slow middleware (promotion-guard awaiting the cart, a
// named middleware's chunk loading) with the old page still clickable.
//
// Global middleware runs first inside Nuxt's guard, in filename order and before any named
// middleware is imported or awaited, and it knows the destination. The `00.` prefix keeps
// this one first.
//
// Which navigations are covered is shouldCoverNavigation's rule: not query-only ones
// (Nuxt2 never covered pagination, page size, sort or filter) and not join step to join
// step, where JoinLayout holds the previous step under its own cover.
export default defineNuxtRouteMiddleware((to, from) => {
  // Client navigations away from a rendered page only: the server never shows the
  // overlay, and the initial navigation (hydration or not) has no old page to cover.
  if (import.meta.server || useNuxtApp().isHydrating || from === START_LOCATION) return

  useRouteCover().value = shouldCoverNavigation(to, from)
})
